import React from 'react';
import { Box } from '@tanium/react-box';
import styled from '@tanium/react-emotion';
import { ThemeFontWeights } from '@tanium/theme-data';
import { PillBaseProps } from './PillBase';

export type TooltipContentProps = Pick<PillBaseProps, 'keyForValue' | 'children'>;

const NoWrapText = styled('span')({
  whiteSpace: 'nowrap',
});

export const TooltipContent = ({ keyForValue, children }: TooltipContentProps) => {
  const getKeyForValue = () => {
    let keyForValueContent = null;
    if (keyForValue) {
      keyForValueContent = (
        <Box as={NoWrapText} overflow="hidden">
          {keyForValue}:{' '}
        </Box>
      );
    }
    return keyForValueContent;
  };

  return (
    <>
      {getKeyForValue()}
      <Box as="span" fontWeight={keyForValue ? ThemeFontWeights.Bold : undefined}>
        {children}
      </Box>
    </>
  );
};
